import { Constants } from "../config/constants";
const isAnnualReturnsDueAfterCompanyStruckOff = (company) => {
  const today = new Date();
  const registrationDate = new Date(company?.registrationDate);
  const dateOfStruckOff = new Date(company?.effectiveFrom);

  if (company?.status !== Constants.ENTITY_STATUS.STRUCK_OFF) {
    return false;
  }

  if (
    !registrationDate ||
    isNaN(registrationDate.getTime()) ||
    !dateOfStruckOff ||
    isNaN(dateOfStruckOff.getTime())
  ) {
    return false;
  }

  const registrationDay = registrationDate.getDate();
  const registrationMonth = registrationDate.getMonth();

  let currentYear = registrationDate.getFullYear() + 1;
  const currentYearToday = today.getFullYear();

  while (currentYear <= currentYearToday) {
    const anniversaryDate = new Date(
      currentYear,
      registrationMonth,
      registrationDay
    );

    if (anniversaryDate > dateOfStruckOff && anniversaryDate <= today) {
      return true;
    }

    currentYear++;
  }

  return false;
};

export default isAnnualReturnsDueAfterCompanyStruckOff;
